import { Component, OnInit } from '@angular/core';
import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { FlightEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { BaseComponent } from '../../../core/components/base_components/base-componet';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-flights',
  templateUrl: './flights.component.html',
  styleUrls: ['./flights.component.css'],
  standalone: false
})
export class FlightsComponent extends BaseComponent implements OnInit {
  flightsViewController: any;
  srchFromResults = false;
  searchParams: FlightEnterpriseSearchInterface;

  constructor(
    public searchService: EnterpriseSearchService,
    private titleService: Title,
    translateService: TranslateService,
    public themeService: ThemeService
  ) {
    super(titleService, translateService);
  }

  ngOnInit(): void {
    this.titleService.setTitle(
      `Flight results ${this.themeService.isLightningEnv ? ' - LightUk' : ''}`
    );
    this.searchParams = this.searchService.searches[ServiceType.Flight];
  }
}
